import React, { MouseEvent, useState } from 'react';
import i18n from 'i18next';
import { murmurhash } from '../../../lib/js/hash';

import Form, { FormTemplate, FormUtils } from '../../molecules/Form';
import FormSubmitOrCancel from '../../molecules/Form/components/FormSubmitOrCancel/FormSubmitOrCancel';
import { InteractionStatus } from '../../../types/InteractionStatus';
import IForm from '../../../types/IForm';

interface InstantSubmitOrCancelProps {
  containerModifier?: string;
  transnamespace: string;
  model: IForm;
  approveAction: string;
  rejectAction: string;
}

export function InstantSubmitOrCancel({
  containerModifier,
  transnamespace,
  model,
  approveAction,
  rejectAction,
}: InstantSubmitOrCancelProps) {
  const [currentAction, setCurrentAction] = useState<string | null>(null);
  const id = murmurhash(approveAction);
  const headlineId = murmurhash(rejectAction);

  /**
   * Handle the <FormSubmitOrCancel /> button events
   * @param {event} event
   * @param {string} action
   * @param {FormModel} formModel
   */
  const handleAction = (event: MouseEvent, action: string, formModel: any) => {
    event.preventDefault();
    setCurrentAction(action);
    formModel.submit();
  };

  const createModelsWithUrl = () => {
    const model1 = { ...model, url: approveAction };
    const model2 = { ...model, url: rejectAction };
    return [model1, model2];
  };

  const getCurrentModelIndex = () => {
    return currentAction === 'approve' ? 0 : 1;
  };

  const createStatusText = (models: any[]) => {
    const { status } = models[getCurrentModelIndex()].model;
    return i18n.t(`${transnamespace}:instantinteraction.${currentAction}.${status}`);
  };

  const currentModelStatus = (models: any[]) => {
    return models[getCurrentModelIndex()].model.status;
  };

  const renderTemplate = (models: any[]) => {
    return (
      <>
        {currentModelStatus(models) !== InteractionStatus.SUCCESS && (
          <>
            {FormUtils.renderHiddenFields(models[0].model.parameter)}
            <FormSubmitOrCancel
              headline={i18n.t(`${transnamespace}:instantinteraction.question`) as string}
              headlineId={headlineId}
              hierarchy={3}
              acceptButtonType="submit"
              acceptFormAction={approveAction}
              acceptAction={(event: MouseEvent<HTMLButtonElement>) => handleAction(event, 'approve', models[0].model)}
              cancelButtonType="submit"
              cancelFormAction={rejectAction}
              cancelAction={(event: MouseEvent) => handleAction(event, 'reject', models[1].model)}
              hideSubmitButton={false}
            />
          </>
        )}
        <div aria-live="polite">
          {currentModelStatus(models) !== InteractionStatus.NONE &&
            FormUtils.getStatusMessageElement(
              {
                id,
                text: createStatusText(models),
              },
              currentModelStatus(models),
            )}
        </div>
      </>
    );
  };

  return (
    <Form id={id} model={createModelsWithUrl()} ariaLabelledby={headlineId} containerModifier={containerModifier}>
      <FormTemplate>{renderTemplate as any}</FormTemplate>
    </Form>
  );
}
